export const items = [
  {
    id: 1,
    image: "/images/cashewButter.jpg",
    title: "Cashew Butter",
    price: 20,
    category: "groceries",
  },
  {
    id: 2,
    image: "/images/coffeeAsorted.jpg",
    title: "Coffee Asorted",
    price: 50,
    category: "groceries",
  },
  {
    id: 3,
    image: "/images/cookies.jpg",
    title: "Cookies",
    price: 25,
    category: "groceries",
  },
  {
    id: 4,
    image: "/images/edibleOil.jpg",
    title: "Edible Oil",
    price: 34,
    category: "groceries",
  },
  {
    id: 5,
    image: "/images/eggs.jpg",
    title: "Eggs",
    price: 50,
    category: "groceries",
  },
  {
    id: 6,
    image: "/images/gucciPerfume.jpg",
    title: "Gucci Perfume",
    price: 100,
    category: "toiletries",
  },
  {
    id: 7,
    image: "/images/himalayaFacewash.jpg",
    title: "Himalaya Face Wash",
    price: 30,
    category: "toiletries",
  },
  {
    id: 8,
    image: "/images/lorealShampoo.jpg",
    title: "Loreal Shampoo",
    price: 20,
    category: "toiletries",
  },
  {
    id: 9,
    image: "/images/missDiorPerfume.png",
    title: "Miss Dior Perfume",
    price: 120,
    category: "toiletries",
  },
  {
    id: 10,
    image: "/images/orangeJuice.jpg",
    title: "Orange Juice",
    price: 35,
    category: "groceries",
  },
  {
    id: 11,
    image: "/images/organicHoney.jpg",
    title: "Organic Honey",
    price: 55,
    category: "groceries",
  },
  {
    id: 12,
    image: "/images/panteneShampoo.jpg",
    title: "Pantene Shampoo",
    price: 15,
    category: "toiletries",
  },
  {
    id: 13,
    image: "/images/pondsFacewash.jpg",
    title: "Ponds Face Wash",
    price: 25,
    category: "toiletries",
  },
  {
    id: 14,
    image: "/images/sanitizer.jpg",
    title: "Sanitizer",
    price: 30,
    category: "toiletries",
  },
  {
    id: 15,
    image: "/images/redChillies.jpg",
    title: "Red Chillies",
    price: 10,
    category: "groceries",
  },
];
